import { Navigate } from 'react-router';
import type { ModuleRoute } from '../types';
import { CompaniesPage } from './CompaniesPage';
import { DevicesPage } from './DevicesPage';
import { EvacuationPage } from './EvacuationPage';
import { HistoryPage } from './HistoryPage';
import { PhonesPage } from './PhonesPage';
import { SettingsPage } from './SettingsPage';

/**
 * Pages of this area (shared reception, building area: Evacuation (phone-first live list that keeps the last list when offline),
 * Companies (order), History, Devices, Marshal phones (invite, list, remove), Settings). Owned by shared reception task W-SR3;
 * only that task edits files in this folder. Building roles are not permissions: the menu entries come from /me/capabilities,
 * administrator-only pages show a notice to marshals, and the server refuses anyone without the role.
 */
export const routes: ModuleRoute[] = [
  { path: '/building', element: <Navigate to="/building/evacuation" replace />, area: 'building' },
  { path: '/building/evacuation', element: <EvacuationPage />, area: 'building' },
  { path: '/building/companies', element: <CompaniesPage />, area: 'building' },
  { path: '/building/history', element: <HistoryPage />, area: 'building' },
  { path: '/building/devices', element: <DevicesPage />, area: 'building' },
  { path: '/building/phones', element: <PhonesPage />, area: 'building' },
  { path: '/building/settings', element: <SettingsPage />, area: 'building' },
];
